import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { useState } from 'react';
import { BaseQuestionAnswerComponent } from '../../../../question-v2/bases';
import styled from '@xstyled/styled-components';
import { Radio } from 'antd';
import { useQuestionContext } from '../../../../question-v2/core';
import { AnswerItem } from './components';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n\n  margin-top: ", ";\n"])), getSize('padding12'));
var AnswerGroup = styled(Radio.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  width: 100%;\n"])), getSize('padding12'));
export var SingleChoiceAnswerComponent = function SingleChoiceAnswerComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var correctAnswerId = states.correctAnswerId;
  var onSelectedAnswer = actions.onSelectedAnswer;

  var _useState = useState(null),
      selectedAnswerId = _useState[0],
      setSelectedAnswerId = _useState[1];

  var handleSelectAnswerChange = function handleSelectAnswerChange(e) {
    setSelectedAnswerId(e.target.value);
    onSelectedAnswer === null || onSelectedAnswer === void 0 ? void 0 : onSelectedAnswer(e.target.value);
  };

  return /*#__PURE__*/_jsx(BaseQuestionAnswerComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsx(StyledAnswerContainer, {
      children: /*#__PURE__*/_jsx(AnswerGroup, {
        onChange: handleSelectAnswerChange,
        value: selectedAnswerId ? selectedAnswerId : correctAnswerId,
        children: question.answers.map(function (answer, index) {
          return /*#__PURE__*/_jsx(AnswerItem, {
            answer: answer,
            index: index,
            isSelected: selectedAnswerId === answer.id.toString(),
            readonly: false,
            isShowCorrectAnswer: false
          }, answer.id.toString());
        })
      })
    })
  });
};